import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MonacoEditorModule } from 'ngx-monaco-editor';
import { ExpEditorComponent } from './exp-editor.component';
import { handleMonacoLoad } from './monaco-controller';

@NgModule({
  declarations: [
    ExpEditorComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MonacoEditorModule.forRoot({
      onMonacoLoad: handleMonacoLoad
    }),
  ],
  exports: [
    ExpEditorComponent,
  ]
})
export class ExpEditorModule { }
